import { all, fork, put, takeEvery, call, takeLatest } from 'redux-saga/effects';
import { WareHouseActionTypes } from './constants';

import { wareHouse, createWareHouse, updateWareHouse, deleteWareHouse, uploadWareHouse } from './api';
/**
 * Login the user
 * @param {*} payload - username and password
 */

function* wareHouseDataGetFunction(data) {
    try {
        yield put({
            type: WareHouseActionTypes.WAREHOUSE_DATA_LOADING,
            payload: {},
        });
        const response = yield call(wareHouse, data);
        if (response.data.status) {
            yield put({
                type: WareHouseActionTypes.WAREHOUSE_DATA_SUCCESS,
                payload: { ...response.data },
            });
        } else {
            yield put({
                type: WareHouseActionTypes.WAREHOUSE_DATA_ERROR,
                payload: { ...response.data },
            });
        }
    } catch (error) {
        yield put({
            type: WareHouseActionTypes.WAREHOUSE_DATA_ERROR,
            payload: error,
        });
    }
}

function* wareHouseDataCreateFunction(data) {

    try {
        yield put({
            type: WareHouseActionTypes.CREATE_WAREHOUSE_DATA_LOADING,
            payload: {},
        });
        const response = yield call(createWareHouse, data);
        if (response.data.status) {
            yield put({
                type: WareHouseActionTypes.CREATE_WAREHOUSE_DATA_SUCCESS,
                payload: { ...response.data },
            });
        } else {
            yield put({
                type: WareHouseActionTypes.CREATE_WAREHOUSE_DATA_ERROR,
                payload: { ...response.data },
            });
        }
    } catch (error) {
        yield put({
            type: WareHouseActionTypes.CREATE_WAREHOUSE_DATA_ERROR,
            payload: error,
        });
    }
}
function* wareHouseDataUpdateFunction(payload) {
    try {
        yield put({
            type: WareHouseActionTypes.UPDATE_WAREHOUSE_DATA_LOADING,
        });

        const response = yield call(updateWareHouse, payload);

        if (response && response.data && response.data.status) {
            yield put({
                type: WareHouseActionTypes.UPDATE_WAREHOUSE_DATA_SUCCESS,
                payload: response.data,
            });
        } else {
            yield put({
                type: WareHouseActionTypes.UPDATE_WAREHOUSE_DATA_ERROR,
                payload: response.data,
            });
        }
    } catch (error) {
        yield put({
            type: WareHouseActionTypes.UPDATE_WAREHOUSE_DATA_ERROR,
            payload: { message: error.message },
        });
    }
}

function* wareHouseDataDeleteFunction(payload) {
    try {
        yield put({
            type: WareHouseActionTypes.DELETE_WAREHOUSE_DATA_LOADING,
        });

        const response = yield call(deleteWareHouse, payload);
        if (response && response.data && response.data.status) {
            yield put({
                type: WareHouseActionTypes.DELETE_WAREHOUSE_DATA_SUCCESS,
                payload: response.data,
            });
        } else {
            yield put({
                type: WareHouseActionTypes.DELETE_WAREHOUSE_DATA_ERROR,
                payload: response.data,
            });
        }
    } catch (error) {
        yield put({
            type: WareHouseActionTypes.DELETE_WAREHOUSE_DATA_ERROR,
            payload: { message: error.message },
        });
    }
}

function* wareHouseDataUploadFunction(data) {
    try {
        yield put({
            type: WareHouseActionTypes.UPLOAD_WAREHOUSE_DATA_LOADING,
            payload: {},
        });
        const response = yield call(uploadWareHouse, data);
        if (response.data.status) {
            yield put({
                type: WareHouseActionTypes.UPLOAD_WAREHOUSE_DATA_SUCCESS,
                payload: { ...response.data },
            });
        } else {
            yield put({
                type: WareHouseActionTypes.UPLOAD_WAREHOUSE_DATA_ERROR,
                payload: { ...response.data },
            });
        }
    } catch (error) {
        yield put({
            type: WareHouseActionTypes.UPLOAD_WAREHOUSE_DATA_ERROR,
            payload: error,
        });
    }
}


export function* watchWareHouseDataGet() {
    yield takeLatest(WareHouseActionTypes.WAREHOUSE_DATA_FIRST, wareHouseDataGetFunction);
    yield takeEvery(WareHouseActionTypes.CREATE_WAREHOUSE_DATA_FIRST, wareHouseDataCreateFunction);
    yield takeLatest(WareHouseActionTypes.UPDATE_WAREHOUSE_DATA_FIRST, wareHouseDataUpdateFunction);
    yield takeEvery(WareHouseActionTypes.DELETE_WAREHOUSE_DATA_FIRST, wareHouseDataDeleteFunction);
    yield takeEvery(WareHouseActionTypes.UPLOAD_WAREHOUSE_DATA_FIRST, wareHouseDataUploadFunction);
}

function* wareHouseSaga() {
    yield all([
        fork(watchWareHouseDataGet),
    ]);
}
export default wareHouseSaga;
